import { render, staticRenderFns } from "./OtherSupplierOrderView.vue?vue&type=template&id=a474976a&scoped=true&"
import script from "./OtherSupplierOrderView.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a474976a",
  null
  
)

export default component.exports